import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import CricketGroundView from "./CricketGroundView";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";

export default function CricketGroundPanel() {
  return (
    <Collapsible defaultOpen className="group">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle>Ground View</CardTitle>
          <CollapsibleTrigger asChild>
            <Button variant="ghost" size="sm" className="w-9 p-0 border border-input">
              <ChevronDown className="h-4 w-4 transition-transform duration-200 group-data-[state=open]:rotate-180" />
              <span className="sr-only">Toggle</span>
            </Button>
          </CollapsibleTrigger>
        </CardHeader>
        <CollapsibleContent>
          <CardContent>
            <CricketGroundView />
          </CardContent>
        </CollapsibleContent>
      </Card>
    </Collapsible>
  );
} 